export type OpenInAppVariant = 'GoogleIntent' | 'Universal';

export function calculateOpenInAppVariant(
  shouldShowFancyDeeplinkButton: boolean
): OpenInAppVariant | undefined {
  if (!shouldShowFancyDeeplinkButton) {
    return undefined;
  }

  // Android intent selection is disabled for now: intent URLs behave
  // unpredictably in webviews, so every device gets the universal link flow.
  return 'Universal';
}
